export default "__VITE_ASSET__fzKmoMKY__"